import { UserGroupContent } from "../../components/auth/role/content";

export default function UserGroup () {

  return (
    <>
      <UserGroupContent/>
    </>
  )

}